module.exports = __webpack_public_path__ + "static/media/compass.2b8962a9.svg";